import { useLocation } from "react-router-dom";

/**
 * Returns the current app "base path" — either "/app" (salon tenant area) or
 * "/admin" (agency HQ area). Used by pages shared between the two contexts
 * (Clients CRM, Pipeline, Publish, Email marketing) so their internal links
 * (`${base}/clients/${id}`, `${base}/email/templates/…`, `${base}/tags`) stay
 * inside the correct workspace.
 */
export function useAppBase() {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin") ? "/admin" : "/app";
}
